// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 376) return "static/chunks/376-d5c277410b441666.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "773d5f5f1924c96c" + ".js";
};